import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { RedirectPage, CenterListPage, AdCenterListPage, MeetgoCenterListPage, CenterDetailPage, SendMailPage } from 'app/pages/encarcenter';

function CenterPage() {
	const { url } = useRouteMatch();
	return (
		<Switch>
			<Route
				path={`${url}/mail/:code`}
				component={SendMailPage}
			/>
			<Route
				path={`${url}/location/:code`}
				component={CenterDetailPage}
			/>
			<Route
				exact
				path={`${url}`}
				component={CenterListPage}
			/>
			<Route
				path={`${url}/ad`}
				component={AdCenterListPage}
			/>
			<Route
				path={`${url}/meetgo`}
				component={MeetgoCenterListPage}
			/>

			<Route render={() => <RedirectPage type="404" />} />
		</Switch>
	);
}

export default CenterPage;
